// extracted by mini-css-extract-plugin
module.exports = {"widget":"Item_widget__2NBmB","toolbox":"Item_toolbox__xLvS2"};